import { render, staticRenderFns } from "./tabSys.vue?vue&type=template&id=2a2b3040"
import script from "./tabSys.vue?vue&type=script&lang=js"
export * from "./tabSys.vue?vue&type=script&lang=js"
import style0 from "../../../../../styles/updateProject.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports